/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PolarisProductEAPSettingsEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const polarisProductEAPSettingsEntryPoint: EntryPoint<
	PolarisProductEAPSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<PolarisProductEAPSettingsEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-eap", jiraSpaEntry: "async-polaris-ideas" */ './PolarisEarlyAccessFeaturesSettingsPageDefault.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
